import { render, staticRenderFns } from "./BrandMockup.vue?vue&type=template&id=45fe97d3&"
import script from "./BrandMockup.vue?vue&type=script&lang=js&"
export * from "./BrandMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports